import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminJobsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('job');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
